import { css } from 'styled-components';
import workSansBoldWoff from '../../../../client/fonts/work-sans/WorkSans-Bold.woff';
import workSansBoldWoff2 from '../../../../client/fonts/work-sans/WorkSans-Bold.woff2';
import workSansBoldItalicWoff from '../../../../client/fonts/work-sans/WorkSans-BoldItalic.woff';
import workSansBoldItalicWoff2 from '../../../../client/fonts/work-sans/WorkSans-BoldItalic.woff2';
import workSansRegularItalicWoff from '../../../../client/fonts/work-sans/WorkSans-Italic.woff';
import workSansRegularItalicWoff2 from '../../../../client/fonts/work-sans/WorkSans-Italic.woff2';
import workSansRegularWoff from '../../../../client/fonts/work-sans/WorkSans-Regular.woff';
import workSansRegularWoff2 from '../../../../client/fonts/work-sans/WorkSans-Regular.woff2';
const workSans = css `
  /* WorkSans Regular */
  @font-face {
    font-family: 'WorkSans';
    src: url(${workSansRegularWoff2}) format('woff2'), url(${workSansRegularWoff}) format('woff');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'WorkSans';
    src: url(${workSansRegularItalicWoff2}) format('woff2'),
      url(${workSansRegularItalicWoff}) format('woff');
    font-weight: 400;
    font-style: italic;
    font-display: swap;
  }

  /* WorkSans Bold */
  @font-face {
    font-family: 'WorkSans';
    src: url(${workSansBoldWoff2}) format('woff2'), url(${workSansBoldWoff}) format('woff');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'WorkSans';
    src: url(${workSansBoldItalicWoff2}) format('woff2'),
      url(${workSansBoldItalicWoff}) format('woff');
    font-weight: 700;
    font-style: italic;
    font-display: swap;
  }
`;
export default workSans;
